import { ReactNode } from "react";
import styles from "./Summary.module.css";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";

function Summary({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  return (
    <div className={styles["root"]} data-testid="summary">
      <FixaText
        data-testid="summary-header"
        textStyle={"Body.L"}
        className={styles["header"]}
      >
        {t("summaryString")}
      </FixaText>
      <FixaText data-testid="summary-content" textStyle={"Body.L"}>
        {children}
      </FixaText>
    </div>
  );
}

export default Summary;
